import React from 'react';

import {
  Car,
  ForkKnife,
  HandSoap,
  Newspaper,
  Question,
  // ShoppingCartSimple,
  Truck,
} from '@phosphor-icons/react';
import light from 'src/styles/themes/light';

export const resourceMenu = [
  {
    id: 'blog',
    url: 'https://blog.4intelligence.ai/',
    title: 'Blog',
    description:
      'Mantenha-se atualizado com as novidades do blog da 4intelligence',
    icon: <Newspaper weight="duotone" />,
    color: light.colors.primary,
  },
  {
    id: 'help-center',
    url: '/help-center',
    title: 'Central de Ajuda',
    description: 'Tire suas dúvidas sobre nossas funcionalidades',
    icon: <Question weight="duotone" />,
    color: light.colors.red3,
  },
];

export const casesMenu = [
  {
    id: 'foods',
    url: '/cases/food',
    title: 'Alimentos',
    description: 'Aumento de 26% na receita da companhia',
    icon: <ForkKnife weight="duotone" />,
    color: light.colors.orange4,
  },
  {
    id: 'automobiles',
    url: '/cases/automobiles',
    title: 'Automóveis',
    description: 'Aumento de 45,7% na vendas de caminhões',
    icon: <Car weight="duotone" />,
    color: light.colors.purple4,
  },
  {
    id: 'hygiene-beauty',
    url: '/cases/hygiene-beauty',
    title: 'Higiene e Beleza',
    description: 'Desburocratizando o S&OP',
    icon: <HandSoap weight="duotone" />,
    color: light.colors.primary,
  },
  {
    id: 'logistics',
    url: '/cases/logistics',
    title: 'Logística',
    description: 'Aumento de 10% no total de cargas transportadas',
    icon: <Truck weight="duotone" />,
    color: light.colors.teal4,
  },
  // {
  //   id: 'retail',
  //   url: '/cases/retail',
  //   title: 'Varejo',
  //   description: 'Expandindo a rede de lojas pelo Brasil',
  //   icon: <ShoppingCartSimple weight="duotone" />,
  //   color: light.colors.secondary,
  // },
];
